import React, {useState} from 'react';
import './App.css';
import {ResultsTable} from "./components/pages/results/ResultsTable";
import 'antd/dist/antd.css'
import {Col, Row} from "antd";
import Manage from "./components/Manage";
import MapPage from "./components/pages/map/MapPage";

function App() {
    const [comp,] = useState<number>(Number(new URLSearchParams(window.location.search).get('comp')))
    const [page, setPage] = useState('results')
    const [showIphone, setShowIphone] = useState(false)
    const [showMap, setShowMap] = useState(true)
    const [autoCenter, setAutoCenter] = useState(true)

    function showIphoneToggle() {
        setShowIphone(showIphone => !showIphone)
    }

    function showMapToggle() {
        setShowMap(showMap => !showMap)
    }

    function autoCenterToggle() {
        setAutoCenter(autoCenter => !autoCenter)
    }

    function setPageHandler(page: string) {
        setPage(page)
    }

    return (
        <div className={'app'} >
            <Manage
                comp={comp}
                showMap={showMap}
                showMapToggle={showMapToggle}
                page={page}
                setPageHandler={setPageHandler}
                autoCenter={autoCenter}
                autoCenterToggle={autoCenterToggle}
                showIphoneToggle={showIphoneToggle}
                showIphone={showIphone}
            />
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            { page === 'results' &&
            <>
                <Row>
                    <Col span={24}>

                    </Col>
                </Row>
                <Row>
                    <Col md={{span: 20, offset: 2}} lg={{span: 16, offset: 4}} xl={{span: 14, offset: 5}} xxl={{span: 10, offset: 7}}>
                        <ResultsTable
                            comp={comp}
                        />
                    </Col>
                </Row>
            </>
            }
            { page === 'map' &&
            <Row>
                <Col span={24}>
                    <MapPage
                        comp={comp}
                        showMap={showMap}
                        autoCenter={autoCenter}
                        showIphone={showIphone}
                    />
                </Col>
            </Row>
            }
        </div>
    );
}

export default App;
